import { Component, FC, useEffect, useRef } from "react";
import { Animated, StyleSheet, View, ViewProps } from "react-native";
import LinearGradient from "react-native-linear-gradient";
import { kStyleConst } from "src/kStyle";
import { kColors } from "../kColors";

export type tShimmerProps = {
  loading?: boolean;
  shimmerBackgroundColor?: string | number;
  shimmerDetailColor?: string | number;
  duration?: number;
  shimmerRadius?: number;
};

type tShimmerViewProps = tShimmerProps & ViewProps;

export const ShimmerView: FC<tShimmerViewProps> = (props) => {
  const {
    loading = false,
    shimmerBackgroundColor = kColors.almostWhite,
    shimmerDetailColor = kColors.lightMed,
    duration = 1300,
    shimmerRadius = 0.1,
    children,
    ...viewProps
  } = props;

  const animatedValue = useRef<Animated.Value>(new Animated.Value(0));

  const shimmerAnim = Animated.loop(
    Animated.sequence([
      Animated.timing(animatedValue.current, {
        toValue: 1,
        useNativeDriver: false,
        duration: duration,
      }),
    ]),
  );

  useEffect(() => {
    if (loading) {
      shimmerAnim.start();
    } else {
      shimmerAnim.reset();
    }
  }, [loading, shimmerAnim]);

  const gradientPosition = animatedValue.current.interpolate({
    inputRange: [0, 1],
    outputRange: [-shimmerRadius, 1 + shimmerRadius],
  });

  return (
    <View {...viewProps}>
      {loading && (
        <AnimatedGradient
          position={gradientPosition}
          radius={shimmerRadius}
          backgroundColor={shimmerBackgroundColor}
          detailColor={shimmerDetailColor}
        />
      )}
      <>{children}</>
    </View>
  );
};

class GradientHelper extends Component<{
  position: number;
  radius: number;
  backgroundColor: string | number;
  detailColor: string | number;
}> {
  render() {
    const { position, radius, backgroundColor, detailColor } = this.props;

    return (
      <View style={styles.mShimmerContainer}>
        <LinearGradient
          colors={[backgroundColor, detailColor, backgroundColor]}
          style={styles.mShimmerLinearGradient}
          locations={[position - radius, position, position + radius]}
          useAngle={true}
          angle={135}
          angleCenter={{ x: 0.5, y: 0.5 }}
        />
      </View>
    );
  }
}

const AnimatedGradient = Animated.createAnimatedComponent(GradientHelper);

export default ShimmerView;

const styles = StyleSheet.create({
  mShimmerContainer: {
    backgroundColor: kColors.white,
    height: "100%",
    position: "absolute",
    width: "100%",
    zIndex: 1,
  },
  mShimmerLinearGradient: {
    borderRadius: kStyleConst.kSpacing * 3,
    flex: 1,
  },
});
